module.exports = __webpack_public_path__ + "static/media/create-asset.07289898.png";